import SumsubWebSdk from '@sumsub/websdk-react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CustomLoader } from 'components/CustomLoader/CustomLoader';
import { useAppDispatch } from 'hooks/useAppDispatch';
import useCountry from 'hooks/useCountry';
import { useMemo } from 'react';
import { useGetProfileQuery } from 'store/slices/profile-api';
import {
  useGetSumsubTokenQuery,
  useUpdateUserActionMutation,
} from 'store/slices/verification-api';
import { getVerificationStatusAction } from 'store/verification/verification-actions';

export const Route = createFileRoute(
  '/_authenticated/verification/id-verification',
)({
  component: IdVerification,
});

function IdVerification() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const consentObtainedAt = useMemo(() => new Date().toISOString(), []);
  const countries = useCountry();
  const { data: profile } = useGetProfileQuery();

  const alpha3Country = countries?.find(
    (country: any) => country.code === profile?.countryCode,
  );

  const sumsubPayload = {
    userIp: '192.0.0.1',
    userCountry: alpha3Country?.alpha3Code ?? 'ZAF',
    consentObtained: 'yes',
    consentObtainedAt: consentObtainedAt, // Jumio requires date string in this format
  };

  const {
    isLoading,
    data: sumsubData,
    refetch,
  } = useGetSumsubTokenQuery(sumsubPayload);
  const [updateUserAction, updateUserActionResult] =
    useUpdateUserActionMutation();

  const handleMessage = async (event: any, payload: any) => {
    if (event === 'idCheck.onApplicantStatusChanged') {
      navigate({ to: '/verification/pending' });

      await updateUserAction({
        userActionId: sumsubData?.idUserIdAction!,
        providerReference: profile?.id!,
      });

      dispatch(getVerificationStatusAction());
    }
  };

  return !isLoading ? (
    <SumsubWebSdk
      accessToken={sumsubData?.sdkToken!}
      expirationHandler={async () => {
        const res = await refetch();
        return res.data?.sdkToken!;
      }}
      config={{
        lang: 'en',
        email: profile?.email,
        phone: profile?.msisdn ?? undefined,
      }}
      options={{ addViewportTag: false, adaptIframeHeight: true }}
      onMessage={handleMessage}
      onError={e => console.error('onError', e)}
    />
  ) : (
    <CustomLoader page={true} />
  );
}

export default IdVerification;
